/* eslint-disable @typescript-eslint/no-explicit-any */

export interface LoggerInterface {
    debug(primaryMessage: string, ...supportingData: any[]): void;
    warn(primaryMessage: string, ...supportingData: any[]): void;
    error(primaryMessage: string, ...supportingData: any[]): void;
    info(primaryMessage: string, ...supportingData: any[]): void;
}

export class Logger implements LoggerInterface {
    private readonly _logLevel: number;

    constructor() {
        switch (process.env.logLevel) {
            case 'warn':
                this._logLevel = 1;
                break;
            case 'debug':
                this._logLevel = 2;
                break;
            default:
                this._logLevel = 0;
        }
        this.debug('Logger initialized');
    }

    /**
     * @description This will only show anything if the log level is debug
     */
    debug(primaryMessage: string, ...supportingData: any[]): void {
        if (this._logLevel === 2) {
            console.debug(primaryMessage, ...supportingData);
        }
    }

    /**
     * @description This will only show anything if the log level is debug or warn
     */
    warn(primaryMessage: string, ...supportingData: any[]): void {
        if (this._logLevel >= 1) {
            console.warn(primaryMessage, ...supportingData);
        }
    }

    error(primaryMessage: string, ...supportingData: any[]): void {
        console.error(primaryMessage, ...supportingData);
    }

    info(primaryMessage: string, ...supportingData: any[]): void {
        console.info(primaryMessage, ...supportingData);
    }
}

const logger = new Logger();
export default logger;
